import './page-preloader.styles.scss';

export default angular.module('directives.abPagePreloader', [])
  .directive('abPagePreloader', () => {
    'ngInject';

    return {
      restrict: 'E',
      templateUrl: require('./page-preloader.template.html'),
    };
  })
  .name;
